import React from 'react';
export function Footer() {
  return <footer className="bg-[#050b14] py-5 md:py-8 px-4 text-center border-t border-gray-800" data-id="element-33">
      <div className="max-w-4xl mx-auto" data-id="element-34">
        <p className="text-gray-500 text-xs md:text-sm mb-2 md:mb-4" data-id="element-35">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <p className="text-gray-400 text-xs md:text-sm" data-id="element-36">
          &copy; {new Date().getFullYear()} Estudio Jurídico Listo. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}